/**
 * Copyright © 2026 Adnuntius AS.
 */
import {BurnRateChartComponent} from './burn-rate-chart.component';
import {ChartOptionsFieldsModalComponent} from './chart-options/chart-options-fields-modal.component';
import {ChartOptionsComponent} from './chart-options/chart-options.component';
import {ExtDemPerformanceChartComponent} from './ext-dem-performance-chart.component';
import {HeatmapComponent} from './heatmap.component';
import {LineChartComponent} from './line-chart.component';
import {PerfTotalComponent} from './perf-total-component';
import {PerformanceChartHostComponent} from './performance-chart-host.component';
import {PerformanceChartComponent} from './performance-chart.component';
import {PerformanceTotalsComponent} from './performance-totals.component';
import {RelatedDataChartComponent} from './related-data-chart.component';
import {RelatedDataDomainComponent} from './related-data-domain.component';
import {RelatedDataLocationComponent} from './related-data-location.component';
import {RelatedDataTrafficComponent} from './related-data-traffic.component';
import {SparkChartComponent} from './spark-chart.component';
import {SpeedoComponent} from './speedo.component';

export const CHARTS = [
  SparkChartComponent,
  HeatmapComponent,
  SpeedoComponent,
  BurnRateChartComponent,
  PerfTotalComponent,
  PerformanceChartComponent,
  ExtDemPerformanceChartComponent,
  PerformanceTotalsComponent,
  ChartOptionsComponent,
  ChartOptionsFieldsModalComponent,
  PerformanceChartHostComponent,
  RelatedDataChartComponent,
  LineChartComponent,
  RelatedDataLocationComponent,
  RelatedDataDomainComponent,
  RelatedDataTrafficComponent
];
